import i18n from '@/i18n';
import { trackEvent } from '@/utils/analytics';

/** 選択ファイルを任意フォルダへコピー */
export async function copySelected(handles: FileSystemFileHandle[]) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const dst = await (window as any).showDirectoryPicker({ mode: "readwrite" });
    for (const h of handles) {
      const file = await h.getFile();
      const target   = await dst.getFileHandle(h.name, { create: true });
      const writable = await target.createWritable();
      await file.stream().pipeTo(writable);
    }
    trackEvent('copy_selected', {
      file_count: handles.length,
    });
    alert(i18n.t('alert-copied'));
  }
  
